import { SpotMarketRequestTemplate } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

export class SpotMarketRequestTemplateController extends BaseHttpController {
  static readonly ENDPOINT: string = 'spot-market/template';

  constructor() {
    super(SpotMarketRequestTemplateController.ENDPOINT);
  }

  async findAll(): Promise<SpotMarketRequestTemplate[]> {
    const response = await this.http.get<SpotMarketRequestTemplate[]>('');
    return response.data.map((val) => new SpotMarketRequestTemplate(val));
  }

  async create(
    template: SpotMarketRequestTemplate,
  ): Promise<SpotMarketRequestTemplate> {
    if (template.id) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<SpotMarketRequestTemplate>(
      '',
      template,
    );
    return new SpotMarketRequestTemplate(response.data);
  }

  async update(
    template: SpotMarketRequestTemplate,
  ): Promise<SpotMarketRequestTemplate> {
    if (!template.id) {
      throw new Error('Id expected to be defined when calling update');
    }

    const response = await this.http.put<SpotMarketRequestTemplate>(
      `${template.id}`,
      template,
    );
    return new SpotMarketRequestTemplate(response.data);
  }

  async setDefault(templateId?: number): Promise<void> {
    if (!templateId) {
      throw new Error('Id expected to be defined when calling setDefault');
    }

    await this.http.put<void>(`${templateId}/default`);
  }

  async delete(templateId: number): Promise<void> {
    await this.http.delete<void>(`${templateId}`);
  }
}
